import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ValidarManifestoTransferenciaResponse } from 'src/app/@shared/models/manifesto-transferencia.model';
import { DEF_VOL_COLS, ObjGridVolCols } from 'src/app/@shared/models/selecao-volumes/objeto-grid-volumes.model';
import { SelecaoVolumes, Volume } from 'src/app/@shared/models/selecao-volumes/selecao-volumes.model';

@Component({
  selector: 'app-modal-selecao-volumes',
  templateUrl: './modal-selecao-volumes.component.html',
  styleUrls: ['./modal-selecao-volumes.component.scss']
})
export class ModalSelecaoVolumesComponent implements OnInit {

  isLoading: boolean = false;
  refVolumes: SelecaoVolumes[] = [];
  listaVolumes: any[];
  listaPedidos: ValidarManifestoTransferenciaResponse[];
  codigoBarras: string;
  hasManifestoTransf: boolean;
  replaceManif: boolean = false;
  tipo: number;

  displayedColumns: ObjGridVolCols = DEF_VOL_COLS;
  volumeSelecionado: Volume;

  constructor(
    @Inject(MAT_DIALOG_DATA) {
      objetoVolume,
      codigoBarras,
      exibirColunas,
      tipo
    }: {
      objetoVolume;
      codigoBarras;
      exibirColunas;
      tipo;
    },
    public snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<ModalSelecaoVolumesComponent>
  ) {
    tipo
      ? this.tipo = tipo
      : this.tipo = null;

    this.displayedColumns = ['select', ...exibirColunas];
    if (objetoVolume) {
      this.listaVolumes = objetoVolume
        .filter(r =>
          r.pedido.volumes?.length
        );

      this.listaVolumes.forEach(r =>
        r.pedido.volumes.forEach(v =>
          this.refVolumes[v.pedEtiqueta] = {
            ...r, volumeSelecionado: {
              ...v, pedidoId: r.pedidoId
            },
          }
        )
      );

      this.listaPedidos = objetoVolume.filter(r => !r.pedido?.volumes?.length);
    }
    if (codigoBarras)
      this.codigoBarras = codigoBarras;
  }

  ngOnInit() { }

  gravarVolumes() {
    this.dialogRef.close(this.volumeSelecionado);
  }

  temMedidas(element: Volume): string {
    if (element.altura && element.largura && element.comprimento) {
      return `${element.altura} x ${element.largura} x ${element.comprimento}`;
    } else {
      return '-';
    }
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
